import React from 'react';
import {Field} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {SelectField} from 'components/Fields';

import {required} from 'utils/validators';

const buildBookingOrganisationOption = bookingOrganisation => ({
  value: bookingOrganisation.id,
  label: bookingOrganisation.name
});

const SelectBookingOrganisationField = ({
  isOrganisationRequired,
  disableBookingOrganisation,
  bookingOrganisations
}: any) => {
  if (disableBookingOrganisation) return <div />;

  return (
    <FormField>
      <Label>Organisation</Label>
      <Field
        name="bookingOrganisation"
        component={SelectField}
        validate={isOrganisationRequired ? [required] : []}
        options={bookingOrganisations.map(buildBookingOrganisationOption)}
      />
    </FormField>
  );
};

export default SelectBookingOrganisationField;
